class AppController {
    constructor($rootScope, userApiService, userService, responsive) {
        Object.assign(this, {
            $rootScope,
            userApiService,
            userService,
            responsive
        });

        this.allowNavigation = this.$rootScope.allowNavigation;
    }

    introGuideDone() {
        this.userService.getCurrentUser().then((user) => {
            if (!user.hasFinishedIntroGuide) {
                this.userApiService.setHasFinishedIntroGuideForCurrentUser(true);
            }

            if (!user.hasAcceptedTerms) {
                this.userService.showTermsOfService();
            }
        });
    }
}

AppController.$inject = ['$rootScope', 'userApiService', 'userService', 'responsive'];

export default AppController;
